var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "12.5 12.5 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/remove/Active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7,15.7 L15.7,34.3 L34.3,34.3 L34.3,15.7 L15.7,15.7 Z",
    id: "Border",
    className: "svg-stroke",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 20.000000)",
    className: "svg-stroke",
    strokeLinecap: "square",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.55271368e-14,8.43769499e-13 L9.72271824,9.72271824",
    id: "Line-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.8191672e-14,8.46434034e-13 L9.72271824,9.72271824",
    id: "Line-4",
    transform: "translate(4.861359, 4.861359) scale(-1, 1) translate(-4.861359, -4.861359) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.0414f39743c7544c537dbf228b6adaa4.svg";
export { ForwardRef as ReactComponent };